export default __webpack_public_path__ + "static/media/muntinlupa-map.078bf821.jpg";